var angular = require('angular');
var _module = angular.module('benoit');

require('../../third-party/angular-slick');

_module.requires.push(
    'slickCarousel'
);

_module.controller('TestimonialsCtrl', [
    '$log',

    function TestimonialsCtrl($log) {
        $log.debug('TestimonialsCtrl', this);

        var vm = this;
        vm.model = {
            slick: {
                responsive: [ // More responseive settings are set in updateSlickSettings function
                    {
                        breakpoint: 599,
                        settings: {
                            dots: true
                        }
                    }
                ]
            }
        };
    }
]);

_module.component('testimonials', {
    controllerAs: 'vm',
    controller: 'TestimonialsCtrl',
    template: require('./index.html'),
    bindings: {
        quotes: '<'
    }
});
